import VehicleBlockPrimaryAttributes from "./VehicleBlockPrimaryAttributes";

export default VehicleBlockPrimaryAttributes;
export { VehicleBlockPrimaryAttributes };
